// extracted by mini-css-extract-plugin
module.exports = {"publicationEditorHtmlBody":"publication-editor-html-body_publicationEditorHtmlBody__ffZ1P"};